module.exports = __webpack_public_path__ + "img/icon_5_5.5e8d9cf7.png";